import { render } from "./ProfCard.vue?vue&type=template&id=ea2e604e&scoped=true"
import script from "./ProfCard.vue?vue&type=script&lang=js"
export * from "./ProfCard.vue?vue&type=script&lang=js"

import "./ProfCard.vue?vue&type=style&index=0&id=ea2e604e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea2e604e"]])

export default __exports__